/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi_card__arrival__available_accommodation = /** @type {(inputs: {}) => string} */ () => {
	return `An Ihrem Reiseziel stehen Unterkünfte zur Verfügung.`
};

const en_zoi_card__arrival__available_accommodation = /** @type {(inputs: {}) => string} */ () => {
	return `Accommodations are available in your arrival area.`
};

const es_zoi_card__arrival__available_accommodation = /** @type {(inputs: {}) => string} */ () => {
	return `Hay alojamiento disponible en tu área de destino.`
};

const fr_zoi_card__arrival__available_accommodation = /** @type {(inputs: {}) => string} */ () => {
	return `Des hébergements sont disponibles dans votre zone d’arrivée.`
};

const it_zoi_card__arrival__available_accommodation = /** @type {(inputs: {}) => string} */ () => {
	return `Le sistemazioni sono disponibili nella zona di arrivo.`
};

const nl_zoi_card__arrival__available_accommodation = /** @type {(inputs: {}) => string} */ () => {
	return `Accommodaties zijn beschikbaar in uw aankomstgebied.`
};

const pt_zoi_card__arrival__available_accommodation = /** @type {(inputs: {}) => string} */ () => {
	return `As acomodações estão disponíveis na sua área de chegada.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__available_accommodation = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi_card__arrival__available_accommodation(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi_card__arrival__available_accommodation", locale)
	if (locale === "de") return de_zoi_card__arrival__available_accommodation(inputs)
	if (locale === "en") return en_zoi_card__arrival__available_accommodation(inputs)
	if (locale === "es") return es_zoi_card__arrival__available_accommodation(inputs)
	if (locale === "fr") return fr_zoi_card__arrival__available_accommodation(inputs)
	if (locale === "it") return it_zoi_card__arrival__available_accommodation(inputs)
	if (locale === "nl") return nl_zoi_card__arrival__available_accommodation(inputs)
	return pt_zoi_card__arrival__available_accommodation(inputs)
};